/* tslint:disable */
/* eslint-disable */
/**
 * ADMIN-SERVICE - REST API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.1.0-SNAPSHOT
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { GeoLocationFromJSON, GeoLocationToJSON, } from './';
export function LocationListGeoEntryFromJSON(json) {
    return LocationListGeoEntryFromJSONTyped(json, false);
}
export function LocationListGeoEntryFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'id': !exists(json, 'id') ? undefined : json['id'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'active': json['active'],
        'geoLocation': !exists(json, 'geoLocation') ? undefined : GeoLocationFromJSON(json['geoLocation']),
        'networkId': !exists(json, 'networkId') ? undefined : json['networkId']
    };
}
export function LocationListGeoEntryToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'id': value.id,
        'name': value.name,
        'active': value.active,
        'geoLocation': GeoLocationToJSON(value.geoLocation),
        'networkId': value.networkId
    };
}
